import { useMemo, useState } from "react";
import { ArenaReportTemplateSummarySortField, SortDirection } from "~/graphql/supergraphEnums";
import { useGetArenaReportTemplateSummariesQuery } from "~/graphql/supergraphHooks";

export type ArenaOption = {
  id: number;
  name: string;
};

export const useArenaOptions = (skip: boolean) => {
  const [selectedArenaId, setSelectedArenaId] = useState<number | null>(null);

  const { data, loading } = useGetArenaReportTemplateSummariesQuery({
    variables: {
      first: 100,
      sortBy: ArenaReportTemplateSummarySortField.ArenaName,
      sortDirection: SortDirection.Asc,
      activeOnly: true,
    },
    skip,
    fetchPolicy: "cache-and-network",
  });

  const arenas: ArenaOption[] = useMemo(
    () =>
      (data?.arenaReportTemplateSummaries?.edges ?? [])
        .filter(
          (edge): edge is typeof edge & { node: { arenaId: number; arenaName: string } } =>
            edge?.node?.arenaId != null &&
            edge.node.arenaId !== 0 &&
            edge.node.arenaName != null,
        )
        .map((edge) => ({
          id: edge.node.arenaId,
          name: edge.node.arenaName,
        })),
    [data],
  );

  const selectedArenaName = useMemo(
    () => arenas.find((a) => a.id === selectedArenaId)?.name ?? "",
    [arenas, selectedArenaId],
  );

  return {
    arenas,
    arenasLoading: loading,
    selectedArenaId,
    setSelectedArenaId,
    selectedArenaName,
  };
};
